import { render } from "./ManagedCases.vue?vue&type=template&id=22101adf"
import script from "./ManagedCases.vue?vue&type=script&lang=js"
export * from "./ManagedCases.vue?vue&type=script&lang=js"

import "./ManagedCases.vue?vue&type=style&index=0&id=22101adf&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__